import {
  ORDER_HELP_FEEDBACK_REQUEST,
  ORDER_HELP_FEEDBACK_SUCCESS,
  ORDER_HELP_FEEDBACK_FAILURE,
  ORDER_HELP_FEEDBACK_SCORE_REQUEST,
  ORDER_HELP_FEEDBACK_SCORE_SUCCESS,
  ORDER_HELP_FEEDBACK_SCORE_FAILURE,
} from '../../actions/types';

const initialState = {
  error: null,
  loading: false,
};

export default function helpFeedbackReducer(state = initialState, action = {}) {
  const newAction = Object.assign({}, action);
  switch (newAction.type) {
    case ORDER_HELP_FEEDBACK_REQUEST:
    case ORDER_HELP_FEEDBACK_SCORE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case ORDER_HELP_FEEDBACK_FAILURE:
    case ORDER_HELP_FEEDBACK_SCORE_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: newAction.status,
          message: newAction.message,
        },
      };

    case ORDER_HELP_FEEDBACK_SUCCESS:
      return {
        ...state,
        title: newAction.payload.title,
        header: newAction.payload.header,
        data: newAction.payload.data,
        type: newAction.payload.type,
      };
    case ORDER_HELP_FEEDBACK_SCORE_SUCCESS:
      return {
        ...state,
        nextAction: newAction.payload.next_action,
      };
    default:
      return { ...state };
  }
}
